/**
 * Frontend-Service: Priority-Support Benachrichtigungs-Einstellungen
 *
 * REST-Wrapper für GET/PUT /support/notification-preferences.
 * Wird vom useNotificationPreferences-Hook konsumiert.
 */

import apiClient from '../api/apiClient';

export interface NotificationPreferences {
  userId: string;
  webPushEnabled: boolean;
  emailEnabled: boolean;
  nativePushEnabled: boolean;
  quietHoursStart: string | null;
  quietHoursEnd: string | null;
  updatedAt: string;
}

export interface NotificationPreferencesPatch {
  webPushEnabled?: boolean;
  emailEnabled?: boolean;
  nativePushEnabled?: boolean;
}

interface SuccessEnvelope<T> {
  success: true;
  data: T;
}

export async function fetchNotificationPreferences(): Promise<NotificationPreferences> {
  const res = await apiClient.get<SuccessEnvelope<{ preferences: NotificationPreferences }>>(
    '/support/notification-preferences'
  );
  return res.data.data.preferences;
}

export async function updateNotificationPreferences(
  patch: NotificationPreferencesPatch
): Promise<NotificationPreferences> {
  const res = await apiClient.put<SuccessEnvelope<{ preferences: NotificationPreferences }>>(
    '/support/notification-preferences',
    patch
  );
  return res.data.data.preferences;
}
